import { useAlertPopupsContext } from 'context/AlertPopups'
import ErrorPopupContent from './ErrorPopupContent'
import { ERROR_POPUP_DATA } from './consts'

const ErrorPopup = () => {
  const {
    alertPopupsData: {
      errorPopup: { type }
    },
    resetAlertPopupsData
  } = useAlertPopupsContext()

  if (!type) {
    return null
  }

  const { description } =
    ERROR_POPUP_DATA[type as keyof typeof ERROR_POPUP_DATA] ||
    ERROR_POPUP_DATA.default

  return (
    <ErrorPopupContent
      isOpen={!!description}
      description={description}
      onClose={resetAlertPopupsData}
      onButtonClick={resetAlertPopupsData}
    />
  )
}

export default ErrorPopup
